import { BehaviorSubject } from 'rxjs';

export type TFolderCodes = {
	[key: string]: string[];
};
export type TCode = {
	big: boolean;
	small: boolean;
	code: string;
};

export enum QR_SIZE {
	BIG = 'BIG',
	SMALL = 'SMALL',
}

/** Платформа deeplink в QR: один и тот же путь, различается только домен (go.yandex / yango.com) */
export enum QrLinkVendor {
	Yandex = 'YANDEX',
	Yango = 'YANGO',
}

export function buildChargersQrUrl(code: string, vendor: QrLinkVendor): string {
	const params = new URLSearchParams();
	params.set('number', code);
	params.set('vendor', 'bz');
	const query = params.toString();
	if (vendor === QrLinkVendor.Yango) {
		return `https://yango.com/chargers?${query}`;
	}
	return `https://go.yandex/chargers?${query}`;
}

class SessionService {
	listOfCodes$: BehaviorSubject<TFolderCodes> = new BehaviorSubject<TFolderCodes>({});
	selectedCodes$: BehaviorSubject<TFolderCodes> = new BehaviorSubject<TFolderCodes>({});
	selectedCode$: BehaviorSubject<string | undefined> = new BehaviorSubject<string | undefined>(undefined);
	hideTitle$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
	qrLinkVendor$: BehaviorSubject<QrLinkVendor> = new BehaviorSubject<QrLinkVendor>(QrLinkVendor.Yandex);

	static of() {
		return new SessionService();
	}
}

export const sessionStore = SessionService.of();

export type TPrepareCanvas = { active?: boolean; code: string; size: QR_SIZE; promise: Promise<HTMLCanvasElement> };

class CanvasService {
	listOfCanvas$: BehaviorSubject<TPrepareCanvas[]> = new BehaviorSubject<TPrepareCanvas[]>([]);

	static of() {
		return new CanvasService();
	}
}

export const canvasService = CanvasService.of();

export const MANUALLY_ADDED_FOLDER = 'ADDED';
